import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue'
import SalesBotItineraryItem from '@/components/SalesBotItineraryItem.vue'
import SalesBotItineraryStop from '@/components/SalesBotItineraryStop.vue'
import { useSalesBotStore } from '@/store/modules/salesBot'
import { isAddressPopulatedButIncomplete } from '@/utils/address'


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotItinerary',
  emits: ['form:validate'],
  setup(__props, { emit }) {

const salesBotStore = useSalesBotStore()
const { vehicleNeededEntireTrip, addBlankStop, removeStop, updateStop, setVehicleNeededEntireTrip } = salesBotStore
const itineraryStops = computed(() => salesBotStore.itineraryStops)



const stopCount = computed<number>(() => {
  return itineraryStops.value?.length || 0
})

const invalidStopCount = computed<number>(() => itineraryStops.value?.filter(({isValid}) => !isValid)?.length || 0)
const areAllStopsValid = computed<boolean>(() => invalidStopCount.value === 0)

/**
 * Gets the LatLng of the last filled out stop (skipping empty ones)
 * in order to bias the address search results for a subsequent stop.
 *
 * Tracked as a computed value so we can re-evaluate whenever previous
 * stop addresses are changed.
 *
 * @param stopIndex - The index of the stop we want to bias results for
 * @returns a LatLng object (or null if there is not one among previous stops)
 */
const previousStopCoordinates = computed(() => {
  return itineraryStops.value.map((_, stopIndex) => {
    for (let i = stopIndex - 1; i >= 0; i--) {
      const address = itineraryStops.value[i]?.stop?.address
      if (address?.lat && address?.lng) {
        return { lat: address.lat, lng: address.lng }
      }
    }
    return null
  })
})

/* This is used to determine where to show the error message for an incomplete address (if any).
 *
 * @returns The index of the first stop with an incomplete address, or -1 if none found.
 */
const firstStopIndexWithIncompleteAddress = computed(() => {
  return itineraryStops.value.findIndex(({ stop }) => isAddressPopulatedButIncomplete(stop.address))
})

const validate = (): boolean => {
  const isValid = stopCount.value > 0 && areAllStopsValid.value
  emit('form:validate', isValid)
  return isValid
}

watch(itineraryStops, () => {
  validate()
})

watch(invalidStopCount, (_) => {
  validate()
})

return { __sfc: true,salesBotStore, vehicleNeededEntireTrip, addBlankStop, removeStop, updateStop, setVehicleNeededEntireTrip, itineraryStops, emit, stopCount, invalidStopCount, areAllStopsValid, previousStopCoordinates, firstStopIndexWithIncompleteAddress, validate, SalesBotItineraryItem, SalesBotItineraryStop }
}

})